import { createSlice } from "@reduxjs/toolkit";
import { IResponseWithPagination } from "src/@types/api";
import { IClone } from "src/@types/clones";
import { FAVOURITES_SLICE_NAME } from "./actions";
import {
  getFavoritesReducer,
  removeFromFavoritesReducer,
} from "./reducers";

export interface FavoritesState {
  isLoading: boolean,
  data: IResponseWithPagination<IClone>;
}

const initialState: FavoritesState = {
  isLoading: false,
  data: null,
};

export const { reducer: favorites } = createSlice({
  name: FAVOURITES_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    getFavoritesReducer(builder);
    removeFromFavoritesReducer(builder);
  },
});
